import I18n from 'I18n';
import once from 'transmute/once';
import { BOOLEAN } from 'customer-data-objects/property/PropertyTypes';
import * as ObjectSegConstants from '../../objectSeg/constants/constants';
import MissingField from 'customer-data-filters-ui/filterQueryFormat/MissingField';
export default once(() => MissingField({
  type: BOOLEAN,
  name: ObjectSegConstants.DEPRECATED_FILTER,
  label: I18n.text('customerDataFiltersUI.customerDataFilters.FilterOperatorLabelTranslations.DEFAULT.DeprecatedFilter')
}));